<section class="press">
  <div class="row pad press__inner">
    <h1 class="press__title">Press</h1>
    <div class="press__list">
      @for (article of articles; track $index) {
      <a class="press__item" [routerLink]="['/press', article.slug]">
        <div class="press__item-content">
          <div class="press__item-date text-muted">
            {{ article.date }}
          </div>
          <h2 class="press__item-headline">
            {{ article.title }}
          </h2>
        </div>
        <img src="/news-arrow.svg" alt="Navigate to article" />
      </a>
      }
    </div>
  </div>
</section>
